import { render, staticRenderFns } from "./TOS.vue?vue&type=template&id=2edd2181&scoped=true&"
import script from "./TOS.vue?vue&type=script&lang=js&"
export * from "./TOS.vue?vue&type=script&lang=js&"
import style0 from "./TOS.vue?vue&type=style&index=0&id=2edd2181&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edd2181",
  null
  
)

export default component.exports